import { useState } from 'react';

export default function useSurvey () {


    const [token, setToken] = useState()

    const handleSubmitSurvey = async (formData) => {
        const url = 'https://oli.org';
        const user_name = 'api'; // Drupal user name
        const pass = "95kF66'g3osU"; // Drupal user password
        const submitData = {
            _links: {
              type: {
                href: 'https://oli.org/rest/type/node/truck_bus_driver_courses',
              },
            },
            title: { value: 'Railway Safety' },
            field_type: { value: 'Truck Driver' },
            status: { value: 1 },
          }
        
        const combinedData = {...submitData, ...formData};
        if (token) {
            const headers = {
                'Content-Type': 'application/hal+json',
                'Authorization': `Basic ${window.btoa(`${user_name}:${pass}`)}`,
                'X-CSRF-Token': token,
            };
    
            const json = JSON.stringify(combinedData);
    
            fetch(`${url}/node?_format=hal_json`, {
            method: 'POST',
            headers,
            body: json,
            })
            .then((response) => response.json())
            .then((result) => {
                if (result && result.nid && result.nid[0] && result.nid[0].value) {
                console.log(`Truck/Bus Driver Courses node created successfully. ID(${result.nid[0].value})`);
                }
            });
        } else {
            fetch(`${url}/session/token`)
            .then((response) => response.text())
            .then((token) => {
              // Only process request if token is not empty
              if (token) {
                setToken(token)
                const headers = {
                  'Content-Type': 'application/hal+json',
                  'Authorization': `Basic ${window.btoa(`${user_name}:${pass}`)}`,
                  'X-CSRF-Token': token,
                };
          
                const json = JSON.stringify(combinedData);
          
                fetch(`${url}/node?_format=hal_json`, {
                  method: 'POST',
                  headers,
                  body: json,
                })
                  .then((response) => response.json())
                  .then((result) => {
                    if (result && result.nid && result.nid[0] && result.nid[0].value) {
                      console.log(`Truck/Bus Driver Courses node created successfully. ID(${result.nid[0].value})`);
                    }
                  });
              }
            }); 
        }


    }   
    return ({handleSubmitSurvey})
}
